import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// All supported languages
const supportedLanguages = [
  'en', 'es', 'fr', 'zh', 'ru', 'uk', // Major
  'vi', 'tl', 'hi', 'ur', 'ja', 'ko', 'th', // Asian
  'fa', 'ar', 'he', // Middle East
  'ga', 'de', 'pt', 'it', 'pl', 'nl', // European
  'af', 'sw', 'am', 'om', 'ti', 'sid', 'wal', 'gur', 'had', 'gam', 'aar', // Ethiopian
  'ak', 'fat', 'dag', 'gua', 'ha', 'ig', 'ee', 'yo', 'zu', 'xh', 'so' // African
];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
